import React from 'react';
export function Process() {
  const steps = [{
    n: '1',
    title: 'Request Your Free Quote',
    body: 'Fill out our form or call us directly. We respond fast — usually within one business day.'
  }, {
    n: '2',
    title: 'On-Site Inspection',
    body: 'A Moceri professional inspects your roof, reviews shingle options, and gives you a written, upfront estimate.'
  }, {
    n: '3',
    title: 'Expert Installation',
    body: 'Our crew arrives on time, replaces your roof in 1–2 days, and leaves your property spotless.'
  }, {
    n: '4',
    title: 'Lasting Peace of Mind',
    body: 'You get a beautiful, durable shingle roof backed by manufacturer warranties and our workmanship guarantee.'
  }];
  return <section className="bg-[#1a2332] py-20 sm:py-24 text-white relative overflow-hidden" data-id="element-191">
      <div className="absolute inset-0 shingle-pattern opacity-20" data-id="element-192" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-193">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-194">
          <span className="inline-block text-[#2DB8E0] font-bold uppercase tracking-wider text-sm mb-4" data-id="element-195">
            Our Process
          </span>
          <h2 className="font-display italic text-4xl sm:text-5xl leading-tight mb-4" data-id="element-196">
            A Seamless, Stress-Free Experience
          </h2>
          <p className="text-lg text-white/75" data-id="element-197">
            Choose us for a seamless, stress-free experience from start to
            finish.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-198">
          {steps.map(s => <div key={s.n} className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl p-6 hover:border-[#2DB8E0]/50 transition-colors" data-id="element-199">
              <div className="w-12 h-12 rounded-full bg-[#2DB8E0] flex items-center justify-center font-bold text-xl text-white mb-4" data-id="element-200">
                {s.n}
              </div>
              <h3 className="font-bold text-xl mb-2" data-id="element-201">{s.title}</h3>
              <p className="text-white/70 leading-relaxed text-sm" data-id="element-202">{s.body}</p>
            </div>)}
        </div>
      </div>
    </section>;
}